import * as Ariakit from '@ariakit/react';
import { ReactNode } from 'react';
import { styled } from 'styled-components';

import { theme } from '../../../styles';
import { ChevronIconOld } from '../../../assets/icons';
import { staticTextSmallStyle } from '../common/commonStyles';
import { Assets, IconNames } from '../../../assets';
import { zIndex } from '../../../styles/zIndex';
import { unsetButtonStyle } from '../../../utils/unsetButtonStyle';

export { Assets } from '../../../assets';

type NavbarMenuPopoverProps = {
  menuButton: {
    name: string;
    /** If defined, show label (such as "Inloggad som") and icon */
    profileLabel?: string;
    /** Will default to "ProfileIcon" if profileLabel is defined */
    profileIcon?: IconNames;
  };
  children: ReactNode;
};

export const NavbarPopoverMenu = ({
  menuButton: { name, profileIcon, profileLabel },
  children,
}: NavbarMenuPopoverProps) => {
  return (
    <Ariakit.MenuProvider placement="bottom">
      {profileLabel || profileIcon ? (
        <ProfileMenuButton name={name} profileIcon={profileIcon} profileLabel={profileLabel} />
      ) : (
        <StandardMenuButton name={name} />
      )}
      <AriaMenu gutter={defaultAriaMenuGutter}>
        <Ariakit.PopoverArrow size={defaultAriaArrowSize} />
        {children}
      </AriaMenu>
    </Ariakit.MenuProvider>
  );
};

const defaultAriaArrowSize = 30;
const defaultAriaMenuGutter = 0;

const StandardMenuButton = ({ name }: { name: string }) => (
  <AriaMenuButton>
    {name}
    <ChevronIconOld direction="downward" color="white" variant="thin" width={iconWidth} />
  </AriaMenuButton>
);

const ProfileMenuButton = ({
  name,
  profileLabel,
  profileIcon = 'ProfileIcon',
}: {
  name: string;
  /** Such as "Inloggad som:" */
  profileLabel?: string;
  profileIcon?: IconNames;
}) => {
  const Icon = Assets[profileIcon];

  return (
    <AriaMenuButton>
      <Icon color="white" width={14} />
      {profileLabel && <ProfileLabel>{profileLabel}</ProfileLabel>}
      <EllipsisSpan>{name}</EllipsisSpan>
      <ChevronIconOld direction="downward" color="white" variant="thin" width={iconWidth} />
    </AriaMenuButton>
  );
};

const AriaMenu = styled(Ariakit.Menu)`
  background-color: white;
  padding: 18px 0px 10px 0px;
  border-radius: 6px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  width: 346px;
  z-index: ${zIndex.modal};

  /* opacity: 0;
  transition: opacity 0.2s ease-in-out;
  &[data-enter] {
    opacity: 1;
  } */
`;

const columnGap = 6;
const iconWidth = 14;

const AriaMenuButton = styled(Ariakit.MenuButton)`
  ${unsetButtonStyle}

  ${staticTextSmallStyle};
  color: ${theme.colors.white};

  display: flex;
  column-gap: ${columnGap}px;
  align-items: center;

  cursor: pointer;
`;

const EllipsisSpan = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 200px;
  white-space: nowrap;
`;

const ProfileLabel = styled.span`
  ${theme.typography.textXSmall}
  font-size: 10px;
  line-height: 1.33;
  position: absolute;
  transform: translate(0, -100%);
  margin-left: ${columnGap + iconWidth}px;
  color: ${theme.colors.darkBlue40};
`;
